//include 8
jQuery(function(){

    if (!window.pixelpoint.utilities.hasLocalStorage())
        return;

    var queueSize = 10;
    var namespace = "ppHistory";

    var privateFunctions = {

        setItem(key, data) {
            var stringified = JSON.stringify(data);
            window.sessionStorage.setItem(key, stringified);
        },
        getItem(key) {
            var data = window.sessionStorage.getItem(key);
            if (data !== null)
                return JSON.parse(data);
        },
        // queue handling
        push(data) {
            var queue = privateFunctions.getItem(namespace);
            if (!queue || !$.isArray(queue))
                queue = [];
            if (queue.length > 0 && queue[queue.length - 1] == data)
                return;
            if (queue.length > queueSize)
                queue.shift();
            queue.push(data);
            privateFunctions.setItem(namespace, queue);
        },
        pop() {
            var queue = privateFunctions.getItem(namespace);
            if (!queue)
                return null;
            var result = queue.shift();
            privateFunctions.setItem(namespace, queue);
            return result;
        },
        getLastInserted() {
            var queue = privateFunctions.getItem(namespace);
            if (!queue)
                return null;
            return queue[queue.length - 1];
        },
        getAt(index) {
            var queue = privateFunctions.getItem(namespace);
            if (!queue)
                return null;
            if (index < 0)
                index = queue.length - 1 + index;

            if (index > queue.length - 1)
                return null;

            return queue[index];
        },
        size() {
            var queue = privateFunctions.getItem(namespace);
            if (!queue)
                return 0;
            return queue.length;
        },
        getAll() {
            var queue = privateFunctions.getItem(namespace);
            return queue;
        },
        // --------------

        saveCurrentPage() {
            var currentPage = window.location.href;
            privateFunctions.push(currentPage);
        },
        getLastPage() {
            return privateFunctions.getLastInserted();
        },
        getBeforeLastPage() {
            return privateFunctions.getAt(-1);
        },
        getHistory() {
            return privateFunctions.getAll();
        }
    };

    //some logic to make the history work + to expose some functions
    privateFunctions.saveCurrentPage();

    window.pixelpoint.history = {
        getLastVisited() {
            return privateFunctions.getBeforeLastPage();
        },
        getHistory() {
            return privateFunctions.getHistory();
        },
        getCurrent() {
            return privateFunctions.getLastPage();
        },
        visitorCameBack() {
            /*
            var visitedBefore = privateFunctions.getAt(-2);
            var current = privateFunctions.getLastPage();
            if (visitedBefore != null && visitedBefore == current)
                return true;
            return false;
            */
            var history = privateFunctions.getHistory();
            for(var i = 0;i < history.length - 2;i++){
                if(history[i] == history[history.length - 1])
                    return true;
            }
            return false;
        }
    };

});